import { modifier } from '@styles/mixins'
import { colors, typography } from '@styles/vars'
import React from 'react'
import ReactTooltip from 'react-tooltip'
import styled, { css } from 'styled-components'

interface InfoProps {
    label: string
    icon?: React.ReactNode
    transparent?: boolean
    black?: boolean
    tip?: string
    tipId?: string
}

const Info = ({ label, icon, transparent, black, tip, tipId }: InfoProps) => {
    const modifiers: InfoModifiers = { icon, transparent, black }
    return (
        <Wrapper data-tip={tip} data-for={tipId} {...modifiers}>
            <>{icon}{label}</>
            {tip && <ReactTooltip id={tipId} place="bottom" type="light" effect="solid"  backgroundColor={colors.white} borderColor={colors.border} border={true} />}
        </Wrapper>
    )
}

export default React.memo(Info)

/* STYLES */
type InfoModifiers = Pick<InfoProps, "icon" | "transparent" | "black">
const Wrapper = styled.div<InfoModifiers>`
    display: flex;
    align-items: center;
    padding: 5px 7px;
    background: ${colors.white};
    border: 1px solid ${colors.border};
    border-radius: 5px;
    font-size: ${typography.sizes.s};
    font-weight: 700;

    svg {
        margin-right: 5px;
        width: 20px;
        height: 20px;
        fill: ${colors.black};
    }

    ${modifier("transparent", css`
        background: transparent;
        border-color: transparent;
    `)}

    ${modifier("black", css`
        background: ${colors.black};
        border-color: transparent;
        color: ${colors.white};
    `)}
`